import {useSelector} from 'Provider';
import React from 'react';

import ConnectedOfferDestinationList from 'containers/OfferDestinationList';
import {sortedMarketsSelector} from 'store/markets/markets.selectors';
import {
  availableFiltersSelector,
  selectedFilterSelector,
} from 'store/offers/offers.selectors';
import {createSortedDestinationsSelector} from 'store/properties/properties.selectors';

import FilterScreenMobile from './FilterScreenMobile';

const DestinationsMobile = () => {
  const selectedFilters = useSelector(selectedFilterSelector);
  const availableFilters = useSelector(availableFiltersSelector);

  const destinations = useSelector(createSortedDestinationsSelector);

  return (
    <FilterScreenMobile title="DESTINATION">
      <ConnectedOfferDestinationList
        selected={selectedFilters.destination}
        destinations={destinations}
        availableProperties={availableFilters.properties}
      />
    </FilterScreenMobile>
  );
};
export default DestinationsMobile;
